import RevealText from "@/components/shared/RevealText";
import NetworkGrid from "@/components/home/NetworkGrid";
import FinalCta from "@/components/home/FinalCta";
import { useLang } from "@/i18n/LanguageContext";
import SEO from "@/components/shared/SEO";

export default function NetworkPage() {
  const { t } = useLang();
  return (
    <main data-testid="network-page" className="bg-black text-white">
      <SEO title={t.seo.network.title} description={t.seo.network.desc} />
      <section className="pt-40 md:pt-56 pb-16 border-b border-white/10">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10">
          <p className="font-mono-eyebrow text-[var(--dp-accent)] mb-8">{t.network.eyebrow}</p>
          <RevealText
            lines={t.network.title.split("\n")}
            className="font-display text-5xl md:text-7xl lg:text-[112px] leading-[0.9] tracking-tighter font-medium"
          />
          <p className="mt-10 max-w-2xl text-neutral-300 text-lg md:text-xl leading-relaxed">
            {t.network.subtitle}
          </p>
        </div>
      </section>
      <NetworkGrid showHeader={false} />
      <FinalCta />
    </main>
  );
}
